// Classes
import { DemographicsReducerState } from "Containers/Filter/Demographics/classes/demographics.classes";
import { AttributeObject } from "../classes/attributes.classes";

/**
 * @function getAgeAttributes
 *
 * Post-processes the attributes for this section of the filter
 *
 * @param {DemographicsReducerState} demographics - The current state
 * of the Demographics filter section.
 * @return {AttributeObject | undefined}
 *
 * @example
 *
 *     getAgeAttributes(demographics)
 */
export const getAgeAttributes = (demographics: DemographicsReducerState) => {
  let attributeObject = undefined;

  if (demographics.age.selection !== "Any") {
    attributeObject = new AttributeObject(
      `Age = ${demographics.age.value.lower} - ${
        demographics.age.value.upper
      }${(demographics.age.value.upper === 40 && "+") || ""}`,
      "standard"
    );
  }
  return attributeObject;
};
try {
    // @ts-ignore
    getAgeAttributes.displayName = "getAgeAttributes";
    // @ts-ignore
    getAgeAttributes.__docgenInfo = { "description": "", "displayName": "getAgeAttributes", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Attributes/utilities/getAgeAttributes.ts#getAgeAttributes"] = { docgenInfo: getAgeAttributes.__docgenInfo, name: "getAgeAttributes", path: "src/shared/containers/Attributes/utilities/getAgeAttributes.ts#getAgeAttributes" };
}
catch (__react_docgen_typescript_loader_error) { }